import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Loading } from '@carvana/purchase-styles';
import { RedirectWithSearchParams } from '@carvana/purchase-helpers';
import './ducks/reducer';

const Dashboard = lazy(() =>
  import(
    /* webpackChunkName: "dashboard", webpackPreload: true */ './components/dashboard'
  )
);

const Routes = props => {
  const {
    match: { path }
  } = props;

  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path={path} render={() => <Dashboard {...props} />} />

        <Route render={() => <RedirectWithSearchParams to={path} />} />
      </Switch>
    </Suspense>
  );
};

Routes.propTypes = {
  match: PropTypes.shape({}).isRequired
};

export default withRouter(Routes);
